import { Marker as NativeLealetMarker } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useRef } from 'react';
import { Marker as LeafletMarker } from 'react-leaflet';
import { getMapIcon } from './helper';
import MarkerPopup from './marker-popup';
import { BusinessMapLocationItem, MapCategory } from './types';

interface MarkerProps {
  data: BusinessMapLocationItem;
  category: MapCategory;
  onPopupOpen: () => void;
  onPopupClose: () => void;
}

export default function Marker({ data, category, onPopupOpen, onPopupClose }: Readonly<MarkerProps>) {
  const markerRef = useRef<NativeLealetMarker>(null);

  function handlePopupOpen() {
    if (!markerRef.current) return;
    const largeIcon = getMapIcon(markerRef.current?.options?.icon?.options?.iconUrl ?? '', 1.5);
    markerRef.current.setIcon(largeIcon);
    onPopupOpen();
  }

  function handlePopupClose() {
    if (!markerRef.current) return;
    const regularIcon = getMapIcon(markerRef.current?.options?.icon?.options.iconUrl ?? '');
    markerRef.current.setIcon(regularIcon);
    onPopupClose();
  }

  return (
    <LeafletMarker
      ref={markerRef}
      position={[data.coords.x, data.coords.y]}
      icon={getMapIcon(category.pointImg)}
      eventHandlers={{
        popupopen: handlePopupOpen,
        popupclose: handlePopupClose
      }}>
      <MarkerPopup data={data} category={category} />
    </LeafletMarker>
  );
}
